import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '../lib/api'
import type { PaginatedResponse } from '../types'

export interface RegistroMedicao {
  id: string
  equipamento: string
  equipamento_str?: string
  tecnico?: string | null
  tecnico_str?: string
  data_medicao: string
  temperatura_saida_ar?: string | null
  temperatura_retorno_ar?: string | null
  delta_t?: string | null
  pressao_alta?: string | null
  pressao_baixa?: string | null
  corrente_compressor?: string | null
  tensao?: string | null
  observacoes?: string
  ativo: boolean
  criado_em: string
  atualizado_em: string
}

export interface RegistroMedicaoCreateInput {
  equipamento: string
  data_medicao: string
  temperatura_saida_ar?: string | null
  temperatura_retorno_ar?: string | null
  pressao_alta?: string | null
  pressao_baixa?: string | null
  corrente_compressor?: string | null
  tensao?: string | null
  observacoes?: string
}

export function useMedicaoList(params?: { equipamento?: string; tecnico?: string }) {
  return useQuery({
    queryKey: ['medicoes', params],
    queryFn: async () => {
      const r = await api.get<PaginatedResponse<RegistroMedicao>>('/medicoes/', { params })
      return r.data
    },
    staleTime: 1000 * 30,
  })
}

function clean(o: Record<string, unknown>): Record<string, unknown> {
  const out: Record<string, unknown> = {}
  Object.entries(o).forEach(([k, v]) => {
    if (v === '' || v === undefined) return
    out[k] = v
  })
  return out
}

export function useMedicaoCreate() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (data: RegistroMedicaoCreateInput) => {
      const r = await api.post<RegistroMedicao>(
        '/medicoes/',
        clean(data as unknown as Record<string, unknown>),
      )
      return r.data
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['medicoes'] }),
  })
}
